import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js';
import './toast.css';
import {mailCheck,clearMailError,logout} from '../store/authActions';

const MailVerify = ({validMail,mailError,mailCheck,clearMailError,logout}) => {
  const [user, setUser] = useState({userid:'',mail:''})
  const {userid,mail} = user;

  useEffect(()=>{
    if(mailError!==null) {
      M.toast({html: `${mailError}`, classes: 'red darken-2', displayLength: 5000});
      clearMailError();
      setUser({userid:'',mail:''});
    }
  //eslint-disable-next-line
  },[mailError]);

  useEffect(()=>{
    if(!validMail) setUser({userid:'',mail:''});
  //eslint-disable-next-line
  },[validMail]);

  useEffect(()=>{
    if(validMail && userid)
      M.toast({html: 'Verification token has been sent to your email address registered with SciNet', classes: 'green darken-1', displayLength: 5000});
  },[validMail,userid]);

  const onChange = (e) => setUser({...user, [e.target.name]: e.target.value})
  const onSubmitMail = (e) => {
    e.preventDefault();
    mailCheck({userid,mail});
  }

  return (
    <>
      { !validMail &&
        <div className='container form-container'>
          <form onSubmit={onSubmitMail}>
            <div className='form-group'>
              <label htmlFor='userid'>SciNet userid</label>
              <input type='text' name='userid' value={userid} onChange={onChange} required />
            </div>
            <div className='form-group'>
              <label htmlFor='mail'>Registered e-mail</label>
              <input type='text' name='mail' value={mail} onChange={onChange} required />
            </div>
            <input type='submit' value='Request verification token' className='btn btn-primary btn-block' />
          </form>
        </div>
      }
    </>
  );
};

const mapStoreToProps = state => ({
  validMail: state.auth.validMail,
  mailError: state.auth.mailError
});

export default connect(mapStoreToProps,{mailCheck,clearMailError,logout})(MailVerify);
